module.exports = __webpack_public_path__ + "img/gs01.30ebeefb.jpg";